import styled from 'styled-components';

export const EditDocumentWrapper = styled.div`
  .ant-form-item {
    width: 288px;
  }

  .ant-btn {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  & > div:first-child {
    margin-bottom: 16px;
  }
`;
